<template>
    <div class="air-segment mb-4 pb-4">
          <div class="columns is-desktop">
            <div class="column">
              <div class="columns is-mobile">
                <div class="column">
                  <div>
                    <div></div>
                    <div class="is-size-6 is-inline-block">
                      {{ segment.startDate.date | formatDate }}
                                          <span
                      v-if="segment.startDate.date != segment.endDate.date"
                      class="is-size-7 has-text-danger ml-1"
                    >
                     +{{ getDiff(segment.endDate.date, segment.startDate.date) }} day
                    </span>
                    </div>

                  </div>
                  <h5 class="is-size-6 has-text-weight-light">
                    {{ $helpers.getAirlineName(segment.airline) }}
                  </h5>

                  <div>
                    <div class="is-size-7 has-text-grey">
                      Flight Number:

                      <span class="has-text-weight-bold has-text-grey-dark"
                        >{{ segment.airline }}{{ segment.flightNumber }}</span
                      >
                    </div>
                  </div>
                  <div class="is-size-7 has-text-grey-dark">
                    Confirmation Number:
                    <span class="has-text-weight-bold">{{
                      segment.confirmationNumber
                    }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="column">
              <div class="columns is-mobile mb-0">
                <div class="column">
                  <div class="is-size-5 has-text-weight-bold has-text-info">
                    {{ segment.origin }}
                  </div>
                </div>
                <div class="column">
                  <div class="is-size-7 pt-3 has-text-centered">
                    <b-icon
                      icon="airplane"
                      class="has-text-grey"
                      custom-class="mdi-rotate-45"
                    ></b-icon>
                  </div>
                </div>
                <div class="column">
                  <div class="is-size-5 has-text-weight-bold has-text-info">
                    {{ segment.destination }}
                  </div>
                </div>
              </div>

              <div class="columns is-mobile">
                <div class="column pt-0">
                  <div class="is-size-7 has-text-grey mt-1">
                    Departs:
                  </div>
                  <div>
                    <span class="is-size-6 has-text-weight-bold">
                      {{ segment.startDate.time | formatTime }}
                    </span>
                  </div>
                </div>
                <div class="column"></div>
                <div class="column pt-0">
                  <div class="is-size-7 has-text-grey mt-1 ">
                    Arrives:
                  </div>

                  <div>
                    <span
                      class="is-size-6 has-text-weight-bold has-text-grey-dark"
                    >
                      {{ segment.endDate.time | formatTime }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
  </template>
  
  <script>
  import moment from "moment";
  export default {
    name: "AirSegment",
    components: {},
    props: {
      segment: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {};
    },
    methods: {
      getDiff(start, end) {
        return moment(start).diff(moment(end), "days");
      },
    },
  };
  </script>
  
  <style>
  .air-segment {
    border-bottom: 1px dashed #ddddde;
  }
  </style>
  